import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";

export const VendorCell = <T extends { counterpartyName: string | null }>({
    row,
}: CellContext<ViewTableFeatures, T, string | null>) => (
    <span>{row.original.counterpartyName ?? "-"}</span>
);
